"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingStationsOnMap = function IconChargingStationsOnMap(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M23.96 4.33c7.293 0 13.284 6.884 13.284 14.827.01 3.072-1.816 7.494-5.409 13.262l-.582.922-.336.52-.959 1.468-.911 1.37a336 336 0 0 1-3.837 5.605l-1.214 1.722-.823-1.094-1.518-2.058a194 194 0 0 1-3.336-4.722q-.428-.626-.828-1.227l-.361-.546q-.356-.54-.683-1.05c-3.976-6.218-6-10.937-6-14.169 0-7.901 6.187-14.83 13.514-14.83m0 2c-6.17 0-11.516 5.986-11.516 12.83 0 2.604 1.717 6.735 5.132 12.214l.554.876q.48.75 1.022 1.565l.267.397.55.811a192 192 0 0 0 3.3 4.673l.677.925 1.42-2.055a303 303 0 0 0 2.671-3.956l.503-.762q.544-.828 1.031-1.587l.28-.44c3.598-5.698 5.404-9.987 5.395-12.66 0-6.899-5.162-12.83-11.285-12.83M23.85 10c4.678 0 8.47 3.797 8.47 8.48s-3.792 8.48-8.47 8.48c-4.677 0-8.469-3.796-8.47-8.48 0-4.683 3.793-8.48 8.47-8.48m0 1c-4.125 0-7.47 3.35-7.47 7.48s3.345 7.48 7.47 7.48c4.126 0 7.471-3.349 7.471-7.48 0-4.13-3.345-7.48-7.47-7.48"
  })));
};

export { IconChargingStationsOnMap, IconChargingStationsOnMap as default };
